import { classNames } from "@frec-js/common-web";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { FC, useEffect, useRef } from "react";

import { TextInfo } from "../../components/TextInfo";
import Amberly from "../../public/webstatic/images/team/amberly-bw.jpg";
import AmberlyColor from "../../public/webstatic/images/team/amberly-color.jpg";
import Ashley from "../../public/webstatic/images/team/ashley-bw.jpg";
import AshleyColor from "../../public/webstatic/images/team/ashley-color.jpg";
import Bhavdeep from "../../public/webstatic/images/team/bhavdeep-bw.jpg";
import BhavdeepColor from "../../public/webstatic/images/team/bhavdeep-color.jpg";
import Dimitri from "../../public/webstatic/images/team/dimitri-bw.jpg";
import DimitriColor from "../../public/webstatic/images/team/dimitri-color.jpg";
import Grace from "../../public/webstatic/images/team/grace-bw.jpg";
import GraceColor from "../../public/webstatic/images/team/grace-color.jpg";
import Hansen from "../../public/webstatic/images/team/hansen-bw.jpg";
import HansenColor from "../../public/webstatic/images/team/hansen-color.jpg";
import Hao from "../../public/webstatic/images/team/hao-bw.jpg";
import HaoColor from "../../public/webstatic/images/team/hao-color.jpg";
import Isabel from "../../public/webstatic/images/team/isabel-bw.jpg";
import IsabelColor from "../../public/webstatic/images/team/isabel-color.jpg";
import John from "../../public/webstatic/images/team/john-bw.jpg";
import JohnColor from "../../public/webstatic/images/team/john-color.jpg";
import Josh from "../../public/webstatic/images/team/josh-bw.jpg";
import JoshColor from "../../public/webstatic/images/team/josh-color.jpg";
import Kevin from "../../public/webstatic/images/team/kevin-bw.jpg";
import KevinColor from "../../public/webstatic/images/team/kevin-color.jpg";
import Max from "../../public/webstatic/images/team/max-bw.jpg";
import MaxColor from "../../public/webstatic/images/team/max-color.jpg";
import Mo from "../../public/webstatic/images/team/mo-bw.jpg";
import MoColor from "../../public/webstatic/images/team/mo-color.jpg";
import Qiyao from "../../public/webstatic/images/team/qiyao-bw.jpg";
import QiyaoColor from "../../public/webstatic/images/team/qiyao-color.jpg";
import Sandeep from "../../public/webstatic/images/team/sandeep-bw.jpg";
import SandeepColor from "../../public/webstatic/images/team/sandeep-color.jpg";
import Shiro from "../../public/webstatic/images/team/shiro.png";
import { SectionProps } from "../types";
export type Freckle = {
  image: StaticImageData;
  colorImage: StaticImageData;
  name: string;
  title: string;
  bio: string;
};
const team: Freckle[] = [
  {
    image: Mo,
    colorImage: MoColor,
    name: "Mo Al Adham",
    title: "Founder and CEO",
    bio: "Mo is a serial entrepreneur. Before Frec, he was the first advisor of Instacart, founder of Twitvid, and a product leader at Twitter.",
  },
  {
    image: Sandeep,
    colorImage: SandeepColor,
    name: "Sandeep Sripada",
    title: "Chief Technology Officer",
    bio: "Sandeep worked at Twitter and Apple prior to joining Frec. He has a Masters degree in CS (specialization: AI) from Stanford University.",
  },
  {
    image: Ashley,
    colorImage: AshleyColor,
    name: "Ashley Rodabaugh",
    title: "Chief Compliance Officer",
    bio: "Frec is Ashley’s 3rd fintech serving as the CCO. Previously she worked for M1, Tastytrade, and Nationwide. She’s also a licensed attorney.",
  },
  {
    image: Dimitri,
    colorImage: DimitriColor,
    name: "Dimitri Rodrigo",
    title: "Head of Brokerage Ops",
    bio: "Dimitri is a brokerage operations principal with 7 years of experience, most recently at M1 Finance. He holds multiple securities licenses.",
  },
  {
    image: Amberly,
    colorImage: AmberlyColor,
    name: "Amberly Jones",
    title: "Head of Growth",
    bio: "Amberly is an experienced startup leader focused on marketing and revenue. Prior to Frec, she spent 4 years building Realm. Passion for personal finance. UC Berkeley grad.",
  },
  {
    image: Bhavdeep,
    colorImage: BhavdeepColor,
    name: "Bhavdeep Sethi",
    title: "Software Engineer",
    bio: "Before Frec, Bhavdeep worked at Twitter and Flipkart. He has done a Masters in Computer Science (Machine Learning) from Columbia University.",
  },
  {
    image: Max,
    colorImage: MaxColor,
    name: "Max Perry Perinato",
    title: "Software Engineer",
    bio: "Max has 10 years of experience building mobile apps for pre-seed to post-exit startups. He has a Masters in CS from Ca'Foscari University of Venice.",
  },
  {
    image: Grace,
    colorImage: GraceColor,
    name: "Grace Noh",
    title: "Product Designer",
    bio: "Before Frec, Grace was a designer at Cruise and VMware. She has a degree in culture and design from UC Berkeley.",
  },
  {
    image: Hansen,
    colorImage: HansenColor,
    name: "Hansen Wang",
    title: "Software Engineer",
    bio: "Hansen worked at Google, Splunk, and Salesforce before Frec. He graduated from University of Waterloo with an engineering degree.",
  },
  {
    image: Qiyao,
    colorImage: QiyaoColor,
    name: "Qiyao Lou",
    title: "Software Engineer",
    bio: "Before Frec, Qiyao worked at Google as an engineer, tech lead and eng manager. She graduated from Carnegie Mellon with an engineering degree.",
  },
  {
    image: Kevin,
    colorImage: KevinColor,
    name: "Kevin Lu",
    title: "Software Engineer",
    bio: "Before Frec, Kevin worked at Google and several other startups. He studied Computer Science at the University of Waterloo and was Frec’s first intern.",
  },
  {
    image: Hao,
    colorImage: HaoColor,
    name: "Hao Li",
    title: "Financial Engineer",
    bio: "Hao is a financial engineer at Frec and former Quantitative Researcher at Akuna Capital. He holds a Ph.D. in Applied Mathematics from UCLA.",
  },
  {
    image: Isabel,
    colorImage: IsabelColor,
    name: "Isabel Tran",
    title: "Marketing Manager",
    bio: "Before Frec, Isabel worked in marketing at Ambi Robotics and The Farmlink Project. She studied Business Management at UC Santa Cruz.",
  },
  {
    image: John,
    colorImage: JohnColor,
    name: "John Morton",
    title: "Account Executive",
    bio: "Senior Account Executive at Frec, dedicated to nurturing clients, making financial tools accessible, and fostering generational wealth. Enjoys the outdoors.",
  },
  {
    image: Josh,
    colorImage: JoshColor,
    name: "Josh Patchik",
    title: "Compliance & Operations",
    bio: "Josh has worked in compliance and operations at several other fintech companies including M1 and Tastytrade. Studied Finance and Analytics at UIC.",
  },
  {
    image: Shiro,
    colorImage: Shiro,
    name: "You",
    title: "Future Freckle",
    bio: "",
  },
];

export const Team: FC<SectionProps> = () => {
  const secondPanel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (secondPanel.current) {
      secondPanel.current.scrollTo(2000, 0);
    }
  }, []);
  return (
    <>
      <div className="grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[auto_1px]">
        <div className="">{/* empty */}</div>
        <div className="dotted-v lg:mx-12 lg:border-x">
          <div className="flex max-w-2xl flex-col gap-4 px-6 py-14 text-black lg:p-14">
            <h2 className="text-[32px] lg:text-[40px]">Meet the team</h2>
            <p className=" ">
              The Frec team is made up of self-proclaimed finance enthusiasts
              who came together from leading technology companies. Driven by a
              shared frustration around antiquated finance tools and costly
              wealth managers, we built Frec to help anyone (including
              ourselves) access modern finance tools that are simple to use and
              low cost.{" "}
            </p>
          </div>
          <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
          <div className="mx-auto flex max-w-full flex-wrap justify-center gap-16 p-20 lg:justify-start">
            {team.slice(0, -1).map((info) => (
              <FrecklePanel key={info.name} info={info} />
            ))}
          </div>
          <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
          <div className="mx-auto flex max-w-full flex-col items-center gap-4 p-14 text-center">
            <div className="inline">
              <span>
                If you’re interested in becoming a Freckle, reach out to us at{" "}
              </span>
              <Link
                className="font-medium hover:underline"
                href="mailto:team@frec.com"
              >
                team@frec.com.
              </Link>
            </div>
            <TextInfo text="This could be you!">
              {team.slice(-1).map((info) => (
                <FrecklePanel key={info.name} info={info} />
              ))}
            </TextInfo>
            <div className="mt-6 inline">
              <span>For media inquiries, please contact </span>
              <Link
                className="font-medium hover:underline"
                href="mailto:press@frec.com"
              >
                press@frec.com.
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FrecklePanel: FC<{ info: Freckle; className?: string }> = ({
  info: { name, image, colorImage, title, bio },
  className,
}) => {
  return (
    <div className="flex w-[224px] flex-col items-center gap-4 lg:items-start">
      <div
        key={name}
        className={classNames(
          "group relative h-[170px] w-[170px] shrink-0 cursor-pointer lg:h-[224px] lg:w-[224px]",
          className,
        )}
      >
        <Image
          src={image}
          className="absolute h-full w-full object-cover"
          alt={name}
        />
        <Image
          src={colorImage}
          className="absolute h-full w-full cursor-default object-cover opacity-0 transition-opacity duration-200 ease-out hover:opacity-100"
          alt={name}
        />
      </div>
      <div className="flex flex-col items-center gap-2 text-black lg:items-start">
        <p className="text-24 font-medium">{name}</p>
        <p className="text-[14px] font-medium uppercase">{title}</p>
      </div>
      <p className="text-frecXDarkGray text-14 text-center lg:text-left">
        {bio}
      </p>
    </div>
  );
};
